import { RegistrationContactStatus, RegistrationStatus } from "@fieldday/fielddayportal-model"
import { ScheduledActivityForView } from "./Activity"
import { UserInfo } from "./UserInfo"

export interface Registration {
  id?: string
  status: RegistrationStatus
  user: UserInfo
  userId?: string
  scheduledActivityId: string
  scheduledActivity?: ScheduledActivityForView
  createdAt?: Date
  contactStatus: RegistrationContactStatus
  inviteTokenId?: string | null,
  guestTokenId?: string | null,
  invitedByUserId?: string | null,
  orgUnitId?: string | null,
  confirmedAt?: string | null,
  teamRole?: string | null,
}


export function displayRegStatus(registration: Registration, isPastEnd?: boolean): string {
  switch (registration.status) {
    case RegistrationStatus.Registered:
      return isPastEnd ? "Attended" : "Registered"
    case RegistrationStatus.ReviewComplete:
      return "Attended"
    case RegistrationStatus.NoAttendance:
      return "Absent"
    case RegistrationStatus.Withdrawn:
      return "Withdrawn"
    case RegistrationStatus.Waiting:
      return "Waiting"
    case RegistrationStatus.Point_Of_Contact:
      return "Point of contact"
  }
}

export function getEventRegStatus(
  registration: Registration | undefined, sa: ScheduledActivityForView
): "Pending" | RegistrationStatus | undefined {
  if(!registration) return
  // regardless of what type of event, if there's a donation required, check for confirmedAt
  if(sa.config?.minDonationCents && sa.config.minDonationCents > 0 && !registration.confirmedAt) return "Pending"
  return registration.status
}
